import { ContextLog } from "@/backend/models/contextLog";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { CONTEXT_LOG_SUBJECT_TYPES } from "@/types/contextLogTypes";
import { Trash2 } from "lucide-react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";


export default function ContextLogViewer({ subjectId, subjectType, popoverPlacement = 'right', allowDelete = false }: { subjectId: string, subjectType: CONTEXT_LOG_SUBJECT_TYPES, popoverPlacement?: 'bottom' | 'top' | 'right' | 'left', allowDelete?: boolean }) {
  const contextLogs = useParameterStore(useShallow(state => state.contextLogs.filter((log) => log.subjectId === subjectId && log.subjectType === subjectType)));
  const removeContextLogForSubject = useParameterStore(useShallow(state => state.deleteContextLogsForSubject));
  const deleteContextLogAndResetParameter = useParameterStore(useShallow(state => state.deleteContextLogAndResetParameter));

  if (contextLogs.length === 0) return null;

  const onDelete = (log: ContextLog) => {
    if (log.subjectType === CONTEXT_LOG_SUBJECT_TYPES.PARAMETER) {
      void deleteContextLogAndResetParameter(log);
    } else {
      void removeContextLogForSubject(log.subjectId, log.subjectType);
    }
  };

  return (
    <OverlayTrigger
        trigger='click'
        placement={popoverPlacement}
        rootClose
        overlay={
          <Popover placement='bottom' className='warning-popover' style={{ minWidth: '350px' }}>
            <Popover.Header>
              {I18n.get('overrideNotes')}
            </Popover.Header>
            <Popover.Body>
              {contextLogs.map((log) => (
                <div key={log.id} className='border border-grey rounded p-2 d-flex justify-content-between'>
                  <div className='d-flex flex-column'>
                    <div className='text-wrap'>{I18n.get('overrideNote')}: {log.note}</div>
                    <div>{I18n.get('overrideBy')}: {log.userEmail}</div>
                  </div>
                  { allowDelete && <button type='button' className='btn btn-sm btn-red-light' style={{ maxHeight: '32px' }} aria-label={I18n.get('delete')} onClick={() => onDelete(log)}><Trash2 size={16} /></button>}
                </div>
              ))}
            </Popover.Body>
          </Popover>
        }
      >
        <button type='button' className='d-flex align-items-center border-0 bg-transparent link-warning'>
          <p className='link-primary'>{I18n.get('overrideNotes')}</p>
        </button>
      </OverlayTrigger>
  );
}
